var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('b-card',{staticClass:"text-center",attrs:{"bg-variant":"warning","text-variant":"white","header":"404","footer":_vm.wrongURL}},[_c('p',{staticClass:"card-text"},[_vm._v("Seite nicht gefunden.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }